<div class="caption-bar">
  <div class="caption">{{ "absence.requests" | translate }}</div>
  <ion-button (click)="openAbsenceFormModal()">
    <ion-icon size="large" name="add"></ion-icon>
  </ion-button>
</div>

<lib-absence-overview
  (selectedWorkerChanged)="selectedUser = $event"
></lib-absence-overview>
